import React, { useState, useEffect } from 'react';
import { Carousel, CarouselItem, Image, SliderContainer } from './SliderStyle';
import teamcenterService1 from '../../../assets/images/CommpanyOverview/homepageslider1.jpg';
import teamcenterService2 from '../../../assets/images/CommpanyOverview/homepageslider2.jpg';
import teamcenterService3 from '../../../assets/images/CommpanyOverview/homepageslider3.jpg';



const images = [
  teamcenterService1,
  teamcenterService3, 
  teamcenterService2
  
];

const Slider = () => {
  const [index, setIndex] = useState(0);
  const totalItems = images.length;
  const delay = 2000;

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % totalItems);
  };

 

  useEffect(() => {
    const interval = setInterval(nextSlide, delay);
    return () => clearInterval(interval);
  }, []);

  return (
    <SliderContainer className="slider-container">
      <Carousel id="carousel--3d">
        {images.map((src, i) => (
          <CarouselItem
            key={i}
            className={`carousel-3d-item ${i === index ? 'active' : (i === (index + 1) % totalItems ? 'right' : 'left')}`}
          >
            <div className="slide-img">
              <Image className="images" src={src} alt={`Slide ${i + 1}`} />
            </div>
          </CarouselItem>
        ))}
      </Carousel>
    </SliderContainer>
  );
};

export default Slider;
